import React, { useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import { STOREORDER_LIST_QUERY } from "../Queries";
import Presenter from "./Presenter/List";
import qs from "qs";
import Moment from "moment";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import { datePlus9, orderNumber } from "../../../../Components/User/UserNames";
import { graphqlUri } from "../../../../Config/Env";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));

  const store = queryString.store ? queryString.store : "";
  const startSearchDate = queryString.startSearchDate
    ? queryString.startSearchDate
    : "2020-09-01";
  const endSearchDate = queryString.endSearchDate
    ? queryString.endSearchDate
    : Moment().format("YYYY-MM-DD");
  const page = queryString.page ? queryString.page : 1;

  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (store ? "store=" + store + "&" : "") +
    (startSearchDate ? "startSearchDate=" + startSearchDate + "&" : "") +
    (endSearchDate ? "endSearchDate=" + endSearchDate + "&" : "");

  const { data, loading } = useQuery(STOREORDER_LIST_QUERY, {
    variables: {
      store,
      startSearchDate,
      endSearchDate,
      orderBy: "id_DESC",
      skip,
      first,
    },
  });
  const [ledgerListMutation] = useMutation(STOREORDER_LIST_QUERY);
  const [csvData, setCsvData] = useState([]);
  const downloadButton = useRef();

  const onStartDateSelect = (date) => {
    var date = Moment(date).format("YYYY-MM-DD");

    const uri =
      "?" +
      (store ? "store=" + store + "&" : "") +
      (date ? "startSearchDate=" + date + "&" : "") +
      (endSearchDate ? "endSearchDate=" + endSearchDate + "&" : "");

    history.push(`${uri}page=1`);
  };
  const onEndDateSelect = (date) => {
    var date = Moment(date).format("YYYY-MM-DD");

    const uri =
      "?" +
      (store ? "store=" + store + "&" : "") +
      (startSearchDate ? "startSearchDate=" + startSearchDate + "&" : "") +
      (date ? "endSearchDate=" + date + "&" : "");

    history.push(`${uri}page=1`);
  };
  const onPeriodConfig = (e) => {
    var startDate = null;
    var endDate = null;
    if (e.target.value === "ALL") {
    }
    if (e.target.value === "1W") {
      startDate = Moment().subtract(1, "w").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "1M") {
      startDate = Moment().subtract(1, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "3M") {
      startDate = Moment().subtract(3, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "6M") {
      startDate = Moment().subtract(6, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }

    const uri =
      "?" +
      (store ? "store=" + store + "&" : "") +
      (startDate ? "startSearchDate=" + startDate + "&" : "") +
      (endDate ? "endSearchDate=" + endDate + "&" : "");

    history.push(`${uri}page=1`);
  };
  const DownloadButton = () => {
    const handleDownload = async () => {
      try {
        const token = localStorage.getItem("token");
        const params =
          (store ? `store=${store}&` : "") +
          (startSearchDate ? `startDate=${startSearchDate}&` : "") +
          (endSearchDate ? `endDate=${endSearchDate}&` : "");
        const res = await fetch(`${graphqlUri}/excels/storeOrders?${params}`, {
          method: "POST",
          mode: "cors",
          headers: { Authorization: token ? `Bearer ${token}` : "" },
        });
        if (!res.ok) {
          const msg = await res.text();
          toast.error(msg || "엑셀 다운로드에 실패했습니다.");
          return;
        }
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "상점결제내역.xlsx";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        a.remove();
      } catch (e) {
        console.log(e);
        toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
      }
    };
    return (
      <button className="btn btn-white m-r-5" onClick={handleDownload}>
        <i className="fa fa-download m-r-5"></i>엑셀
      </button>
    );
  };

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      store={store}
      startSearchDate={startSearchDate}
      endSearchDate={endSearchDate}
      page={page}
      blockSize={blockSize}
      first={first}
      data={data}
      loading={loading}
      baseUrl={baseUrl}
      onStartDateSelect={onStartDateSelect}
      onEndDateSelect={onEndDateSelect}
      onPeriodConfig={onPeriodConfig}
      DownloadButton={DownloadButton}
    ></Presenter>
  );
});
